import { SwitchWithLabel } from '@newfront-insurance/core-ui';

import { useChatOverlayContext } from '../chat-v2/contexts/chat-overlay-context';

/**
 * Composable toggle primitive for MS Graph (Outlook Connect) enable/disable.
 * Reads and writes outlookConnectEnabled from ChatOverlayContext.
 * The underlying auth flow is handled by useOutlookConnectController in NovaProvider.
 *
 * @example
 * <MSGraphSectionHeader>
 *   <h3>Outlook Connect</h3>
 *   <MSGraphToggle />
 * </MSGraphSectionHeader>
 */
export function MSGraphToggle() {
  const { outlookConnectEnabled, setOutlookConnectEnabled } = useChatOverlayContext();
  return (
    <SwitchWithLabel
      label=""
      enabled={outlookConnectEnabled}
      onClick={() => setOutlookConnectEnabled(!outlookConnectEnabled)}
      locked={false}
      labelPosition="left"
    />
  );
}
